import { useState } from "react";

const useToggle = () => {
    const [open, setOpen] = useState(false);
    const toggle = (): void => {
        setOpen(!open);
    };

    return {
        open,
        toggle
    };
};

export default useToggle;



// WEBPACK FOOTER //
// ./src/hooks/Toggle.ts